import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/fuel-testing.jpg";
import Card3 from "../Images/iso-17025-logo.png";
import "../Pages/OurHistory.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

function CookstoveTesting() {
  return (
    <div className="ne-page">
      <SEO
        title="Cookstove and Fuel Testing"
        description="CIRCODU's Cookstove and Fuel Testing Laboratory is a leading ISO/IEC 17025 accredited regional center for testing and evaluation of cookstoves and fuels, ensuring they meet international standards for safety, efficiency, and environmental impact. The laboratory is equipped with state-of-the-art facilities and highly trained personnel to conduct comprehensive testing and evaluation services."
        keywords="cookstove testing, fuel testing, international standards, safety, efficiency, environmental impact, CIRCODU, cookstove testing Uganda, fuel testing Uganda"
        url="/our-services/cookstoves-and-fuel-testing"
        type="website"
      />

      {/* Hero */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Cookstove and FuelTesting</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Our Services</Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Cookstove and Fuel Testing
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <section className="section border-bottom">
        <div className="container border-top">
          <div className="row">
            <div className="col-md-12 mt-2">
              {/* Intro */}
              <h5 style={{ color: "#008250", fontSize: "16px" }}>
                <b>Cookstoves and Fuel Testing Laboratory</b>
              </h5>
              <p className="texty">
                Established in <b>2010</b>, the CIRCODU Cookstoves and Fuel
                Testing Laboratory has grown from a national asset into a{" "}
                <b>Regional Knowledge and Testing Centre</b> recognized and
                actively supported by the <b>Clean Cooking Alliance</b>. It
                stands today as one of the most credible and well-equipped
                testing facilities for cookstoves and fuels on the continent.
              </p>
            </div>
            <div className="col-md-10">
              {/* Accreditation & Standards */}
              <h5 style={{ color: "#008250", fontSize: "14px" }}>
                <b>🏅 Accreditation and Standards</b>
              </h5>
              <p className="texty">
                Our Laboratory operates to the highest internationally
                recognized standards:
              </p>
              <ul className="texty">
                <li className="mt-2">
                  <b>Uganda National Bureau of Standards (UNBS)</b> —{" "}
                  <i>Certificate No. UNBS/LRS/0023</i>
                </li>
                <li className="mt-2">
                  <b>ISO/IEC 17025:2017</b> — The global benchmark for testing
                  and calibration laboratory competence
                </li>
              </ul>
              <p className="texty">
                When results come from our laboratory, you can trust them.
              </p>

              {/* Laboratory Equipment & Capabilities */}
              <h5 style={{ color: "#008250", fontSize: "14px" }}>
                <b>🧪 Laboratory Equipment and Capabilities</b>
              </h5>
              <p className="texty">
                Our facility is fully equipped with cutting-edge resources to
                deliver accurate, reliable, and comprehensive testing:
              </p>
              <ul className="texty">
                <li className="mt-2">
                  <b>Advanced Emission Testing Equipment</b> — Precision tools
                  for measuring pollutants at every stage of stove use
                </li>
                <li className="mt-2">
                  <b>Fuel Quality Analysis Equipment</b> — Detailed analysis of
                  fuel characteristics and performance properties
                </li>
                <li className="mt-2">
                  <b>Thermo-Efficiency, Durability and Safety Equipment</b> —
                  End-to-end evaluation of how stoves perform, how long they
                  last, and how safe they are to use
                </li>
              </ul>
            </div>
            <div className="col-md-2">
              <div className="imagecard">
                <img
                  src={Card3}
                  alt=""
                  height="auto"
                  width="100%"
                  style={{ borderRadius: "5%" }}
                />
              </div>
            </div>

            <div className="col-md-12 mt-2">
              {/* Our Testing Activities */}
              <h5 style={{ color: "#008250", fontSize: "14px" }}>
                <b>✏️ Our Testing Activities</b>
              </h5>
              <p className="texty">
                Every test we conduct serves a clear purpose to ensure that the
                cookstoves and fuels reaching communities are safe, efficient,
                and fit for purpose:
              </p>
              <table
                className="table table-bordered texty"
                style={{ fontSize: "14px" }}
              >
                <thead style={{ color: "white", backgroundColor: "#008250" }}>
                  <tr>
                    <th>Test</th>
                    <th>Purpose</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <b>Durability Tests</b>
                    </td>
                    <td>
                      Evaluating the lifespan and structural integrity of
                      cookstoves
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Fuel Tests</b>
                    </td>
                    <td>
                      Determining the characteristics and quality of a given
                      fuel
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Water Boiling Tests</b>
                    </td>
                    <td>Measuring the thermal efficiency of the stove</td>
                  </tr>
                  <tr>
                    <td>
                      <b>Safety Tests</b>
                    </td>
                    <td>
                      Assessing the risks and hazards associated with stove use
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Controlled Cooking Tests</b>
                    </td>
                    <td>
                      Measuring fuel consumption during actual meal preparation
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Emissions Testing</b>
                    </td>
                    <td>
                      Quantifying CO<sub>2</sub>, CO, and particulate matter
                      released during stove use
                    </td>
                  </tr>
                </tbody>
              </table>

              {/* Our Expert Team */}
              <h5 style={{ color: "#008250", fontSize: "14px" }}>
                <b>👩‍🔬 Our Expert Team</b>
              </h5>
              <p className="texty">
                The Laboratory is led and operated by a dedicated team of
                skilled professionals:
              </p>
              <ol className="texty mt-2">
                <li>
                  <b>Laboratory Director</b>
                </li>
                <li>
                  <b>Quality Manager</b>
                </li>
                <li>
                  <b>Technical Manager</b>
                </li>
                <li>
                  <b>Senior Laboratory Technician</b>
                </li>
                <li>
                  <b>Laboratory Technician</b>
                </li>
              </ol>
              <p className="texty">
                Together, they uphold the rigorous standards that have made the
                CIRCODU Laboratory a trusted name across Uganda and the wider
                region.
              </p>

              <hr />

              {/* Closing statement */}
              <p className="texty">
                <i>
                  From the laboratory to the community — every test we run is a
                  step toward cleaner air, healthier homes, and a more
                  sustainable future.
                </i>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default CookstoveTesting;
